module.exports = __webpack_public_path__ + "static/media/HomepageTestimonial4.ddaffc0f.webp";